//var url = "https://mobilia-api.complemento360.net" //api/login
var url = process.env.REACT_APP_API_URL


// ============================================
// AUTENTICACIÓN
// ============================================
module.exports.BASE_URL = url + `/api`;
module.exports.LOGIN = url + `/api/login`;
module.exports.SIGNUP = url + `/api/signup/`;

// ============================================
// USUARIOS
// ============================================
module.exports.UPDATE_PASSWORD = url + `/api/update/usuario/password/`; // ← Nueva
module.exports.GET_USUARIO_ALL = url + `/api/get/usuario/all`;
module.exports.GET_USUARIO_ID = url + `/api/get/usuario/id/`;
//module.exports.GET_10_USUARIO_ID = url + `/api/get/usuario/ten/`;
module.exports.GET_USUARIO_USERNAME = url + `/api/get/usuario/username/`;
module.exports.PATCH_USUARIO_ID = url + `/api/patch/usuario/id/`;
module.exports.DELETE_USUARIO_ID = url + `/api/delete/usuario/id/`;
module.exports.CREATE_USUARIO = url + `/api/create/usuario`; // ← Nueva

// ============================================
// CLIENTES
// ============================================
module.exports.GET_CLIENTE_DOCUMENTO = url + `/api/get/cliente/documento/`;
//module.exports.GET_CLIENTE_DOCUMENTO_SIMILAR = url + `/api/get/cliente/documento/similar/`;
module.exports.GET_CLIENTE_NOMBRE = url + `/api/get/cliente/nombre/`;
module.exports.CREATE_CLIENTE = url + `/api/create/cliente/`;
module.exports.PATCH_CLIENTE_DOCUMENTO = url + `/api/patch/cliente/documento/`;
module.exports.DELETE_CLIENTE_DOCUMENTO = url + `/api/delete/cliente/documento/`;
module.exports.GET_CLIENTE_COMPLETO = url + `/api/get/cliente/completo/`; //← Nueva
module.exports.CREATE_CLIENTE_COMPLETO = url + `/api/create/cliente/completo`; //← Nueva
module.exports.DELETE_CLIENTE_COMPLETO = url + `/api/delete/cliente/completo/`; //← Nueva

// ============================================
// CRÉDITOS
// ============================================
module.exports.DELETE_CREDITO_COMPLETO = url + `/api/delete/credito/completo/`;//← Nueva
module.exports.DELETE_ULTIMO_PAGO = url + `/api/delete/ultimo/pago/`;//← Nueva
module.exports.GET_CREDITO_ALL = url + `/api/get/credito/all/`;
module.exports.GET_CREDITO_ID = url + `/api/get/credito/id/`;
module.exports.GET_CREDITO_CLIENTE_ID = url + `/api/get/credito/cliente/`;
module.exports.GET_CREDITO_FINANCIAL_CODE = url + `/api/get/credito/financialCode/`;
module.exports.CREATE_CREDITO = url + `/api/create/credito/`;
module.exports.PATCH_CREDITO_ID = url + `/api/patch/credito/id/`;
module.exports.DELETE_CREDITO_ID = url + `/api/delete/credito/id/`;
module.exports.INFORME_COMERCIAL = url + `/api/get/credito/informe-comercial`;
module.exports.GET_CREDITO_COMPLETO = url + `/api/get/credito/completo/`; //← Nueva
module.exports.CREATE_CREDITO_COMPLETO = url + `/api/create/credito/completo`; //← Nueva
module.exports.UPDATE_CREDITO_COMPLETO = url + `/api/update/credito/completo/`; //← Nueva
module.exports.AGREGAR_CUOTA = url + `/api/agregar/cuota/`; //← Nueva
module.exports.GET_PERIODOS_LIQUIDACION = url + '/api/get/periodos-liquidacion/'; //← Nueva
module.exports.GET_PERIODOS_CON_PAGOS = url + '/api/get/periodos-con-pagos/'; //← Nueva
module.exports.GET_DEUDA_TOTAL = url + '/api/creditos/get/deuda-total/'; //← Nueva

// ============================================
// PAGOS
// ============================================
module.exports.CREATE_PAYMENT = url + `/api/create/payment/`;
module.exports.VALIDAR_PAGO = url + '/api/validar-pago/';// ← Nueva
// ============================================
// ARCHIVOS (CRÉDITOS)
// ============================================
module.exports.GET_FILE_ID = url + `/api/download-credit-file/fileId/`;
module.exports.DELETE_FILE_ID = url + `/api/delete-credit-file/fileId/`;
module.exports.UPLOAD_FILE_ID = url + `/api/upload-credit-file/creditId/`;

// ============================================
// UVR
// ============================================
module.exports.GET_UVR_ALL = url + `/api/get/uvr/all/`;
module.exports.GET_UVR_FECHA = url + `/api/get/uvr/date/`;
module.exports.PUT_UVR = url + `/api/put/uvr/`;
module.exports.UVR_INFO = url + `/api/get/uvr/info`; // ← Agrego
module.exports.UVR_UPLOAD_BATCH = url + `/api/upload/uvr/batch`;// ← Agrego

// ============================================
// UVR LOAD (CARGAS)
// ============================================
module.exports.GET_UVRLOAD_ID = url + `/api/get/uvrLoad/id/`;
//module.exports.GET_UVRLOAD_ALL = url + `/api/get/uvrLoad/all/`;
module.exports.CREATE_UVRLOAD = url + `/api/create/uvrLoad/`;

// ============================================
// AUXILIAR (CONFIGURACIÓN)
// ============================================
module.exports.GET_AUXILIAR_ID = url + `/api/get/auxiliar/id/0`;
module.exports.PATCH_AUXILIAR_ID = url + `/api/patch/auxiliar/id/0`;

// ============================================
// PROCESOS (LIQUIDACIÓN Y CIERRE)
// ============================================
module.exports.LIQUIDATE_ALL_CREDITS = url + `/api/liquidate/credits/`;
module.exports.CIERRE_PERIODO = url + `/api/close/credits/`;
module.exports.CIERRE_PERIODO_FECHA = url + `/api/close/credits-dates/`;
module.exports.RECALCULAR_CREDITO = url + `/api/recalcular/pago`;
// module.exports.RECALCULAR_PROYECCION = url + `/api/restaurar/proyeccion`;

// NUEVO: Backup crédito
module.exports.BACKUP_CREDITO = url + `/api/backup/`;

// NUEVO: Restaurar backup de crédito
module.exports.RESTORE_BACKUP_CREDITO = url + `/api/backup/restore/`;

// ============================================
// BÚSQUEDA GLOBAL
// ============================================ 
module.exports.SEARCH = url + `/api/search`;

// ============================================
// LOGS
// ============================================
module.exports.GET_LOGS = url + `/api/logs`;
module.exports.GET_LOGS_DOWNLOAD = url + `/api/logs/download`;
module.exports.GET_LOGS_OPERACIONES = url + `/api/logs/operaciones`;

// ============================================
// VERIFICACION MORA UVR
// ============================================
module.exports.CHECK_MORA_UVR = url + `/api/creditos/check-mora-uvr`;
